
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.854 12.286a6.563 6.563 0 01-2.854.666 6.577 6.577 0 01-2.854-.666H8.8c-2.65 0-4.8 2.15-4.8 4.8v1.2a2 2 0 002 2h12a2 2 0 002-2v-1.2c0-2.65-2.15-4.8-4.8-4.8h-.346zm.366 1.7a8.204 8.204 0 01-3.22.666 8.207 8.207 0 01-3.219-.666 3.101 3.101 0 00-3.081 3.1v1.2a.3.3 0 00.3.3h12a.3.3 0 00.3-.3v-1.2a3.101 3.101 0 00-3.08-3.1zM11.833 10.3c1.549 0 2.8-1.252 2.8-2.8 0-1.548-1.251-2.8-2.8-2.8a2.798 2.798 0 00-2.8 2.8c0 1.548 1.252 2.8 2.8 2.8zm0 1.7c2.487 0 4.5-2.013 4.5-4.5S14.32 3 11.833 3a4.498 4.498 0 00-4.5 4.5c0 2.487 2.013 4.5 4.5 4.5z","fill":"#4B4B4B"}})])
          )
        }
      }
    